import { DBService } from '../../services/db.service';
import { Component, OnInit, ElementRef, ViewChild, NgZone } from '@angular/core';
import { ServiceItem, Category, Item, Extra, Option } from 'src/app/models/menu.model';
import { ModalController } from '@ionic/angular';
import { Input } from '@angular/core';
import { SERVICE, SUBCATEGORY, CATEGORY, ITEM, getAllergene, getZusatzstoffe } from 'src/environments/constant';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-edit-item',
  templateUrl: './edit-item.component.html',
  styleUrls: ['./edit-item.component.scss']
})
export class EditItemComponent implements OnInit {
  @Input() type: any;
  @Input() category: Category;
  @Input() service: ServiceItem;
  @Input() item: Item;

  @ViewChild('specialPriceCheckbox', { static: false }) private specialPriceCheckbox: any;
  @ViewChild('priceCheckbox', { static: false }) private priceCheckbox: any;

  specialPriceActive: boolean = true
  selectServiceColorExpanded: boolean;

  extrasExpanded: boolean = false
  optionsExpanded: boolean = false
  allergeneExpanded: boolean = false
  zusatzstoffeExpanded: boolean = false

  //Allergene und Zusatzstoffe (Deklaration, s.u.)
  a: boolean; b: boolean; c: boolean; d: boolean; e: boolean; f: boolean; g: boolean; h: boolean; i: boolean; j: boolean; k: boolean; l: boolean; m: boolean; n: boolean; o: boolean;
  p: boolean; q: boolean; r: boolean; s: boolean; t: boolean; u: boolean; v: boolean; w: boolean; x: boolean; y: boolean; z: boolean;

  public allergene: { [id: string]: any } = getAllergene()
  public zusatzstoffe: { [id: string]: any } = getZusatzstoffe();

  constructor(private modalCtrl: ModalController, public util: UtilService, private ngZone: NgZone, private db: DBService) {

  }



  ngOnInit() {
    this.util.isModalOpen = true;

    if (this.type === ITEM && (!this.item.specialPrice || this.item.specialPrice === 0)) {
      this.item.specialPrice = this.item.price
    }

    if (this.type === ITEM && !this.item.takeAwayPrice) {
      this.item.takeAwayPrice = -1
    }


    if (this.type === ITEM && this.item.allergenic) {
      for (let key of Object.keys(this.allergene)) {
        if (this.item.allergenic.includes(key)) this.allergene[key].selected = true;
      }
    }
    if (this.type === ITEM && this.item.additives) {
      for (let key of Object.keys(this.zusatzstoffe)) {
        if (this.item.additives.includes(key)) this.zusatzstoffe[key].selected = true;
      }
    }
  }

  ngAfterViewInit() {
    if (!this.item) return;

    if (!this.item.isSpecialPriceActive) {
      this.ngZone.run(() => {
        this.specialPriceCheckbox.checked = false;
        this.priceCheckbox.checked = true;
      })
    } else {
      this.ngZone.run(() => {
        this.specialPriceCheckbox.checked = true;
        this.priceCheckbox.checked = false;
      })
    }
  }

  changeActivePriceType() {
    if (!this.item.isSpecialPriceActive) {
      this.ngZone.run(() => {
        this.item.isSpecialPriceActive = true
        this.specialPriceCheckbox.checked = true;
        this.priceCheckbox.checked = false;
      })

      // this.specialPriceCheckbox.checked = false;
      // this.priceCheckbox.checked = true;
    } else {
      this.ngZone.run(() => {
        this.item.isSpecialPriceActive = false
        this.specialPriceCheckbox.checked = false;
        this.priceCheckbox.checked = true;
      })
    }
  }

  toggleExtrasExpanded() {
    this.extrasExpanded = !this.extrasExpanded
  }

  toggleOptionsExpanded() {
    this.optionsExpanded = !this.optionsExpanded
  }

  toggleAllergeneExpanded() {
    this.allergeneExpanded = !this.allergeneExpanded
  }

  toggleZusatzstoffeExpanded() {
    this.zusatzstoffeExpanded = !this.zusatzstoffeExpanded
  }

  clickOnZusatzstoff(key: string) {
    if (this.zusatzstoffe[key])
      this.zusatzstoffe[key].selected = !this.zusatzstoffe[key].selected;
  }

  clickOnAllergene(key: string) {
    if (this.allergene[key])
      this.allergene[key].selected = !this.allergene[key].selected;
  }

  addExtra() {
    if (this.type === ITEM) {
      if (!this.item.extras) this.item.extras = []
      this.item.extras.push(new Extra('', 0, 9999))
      this.norm(this.item.extras)
    } else {
      //TODO hier noch in extra liste, damit mann anschliessend auf items verteilen kann
      if (!this.category.extras) this.category.extras = []
      this.category.extras.push(new Extra('', 0, 9999))
    }
  }

  removeExtra(extra: Extra) {
    let extras: Extra[]
    if (this.type === ITEM) extras = this.item.extras;
    else extras = this.category.extras
    
    const index = extras.indexOf(extra, 0);
    if (index > -1) {
      extras.splice(index, 1);
      if (this.type === ITEM) this.norm(extras)
    }
  }

  addOption() {
    if (this.type === ITEM) {
      if (!this.item.options) this.item.options = []
      this.item.options.push(new Option(''))
      this.norm(this.item.options)
    } else {
      //TODO hier noch in options liste, damit mann anschliessend auf items verteilen kann
      if (!this.category.options) this.category.options = []
      this.category.options.push(new Option('', 0, 9999))
      this.norm(this.category.options)
    }
  }

  removeOption(option: Option) {
    let options: Option[]
    if (this.type === ITEM) options = this.item.options;
    else options = this.category.options
    
    const index = options.indexOf(option, 0);    
    if (index > -1) {
      options.splice(index, 1);
      if (this.type === ITEM) this.norm(options)
    }
  }

  public getAllergeneKeys() {
    return Object.keys(this.allergene)
  }

  public getZusatzstoffeKeys() {
    return Object.keys(this.zusatzstoffe)
  }


  moveExtra(extra, step: number) {
    let extras: Extra[]
    if (this.type === ITEM) extras = this.item.extras;
    else extras = this.category.extras
    
    const index = extras.indexOf(extra, 0);
    if (index > -1) {
      extras[index].position = extras[index].position + step
      this.norm(extras)
    }
  }

  moveOption(option, step: number) {
    let options: Option[]
    if (this.type === ITEM) options = this.item.options;
    else options = this.category.options
    
    const index = options.indexOf(option, 0);
    if (index > -1) {
      options[index].position = options[index].position + step
      this.norm(options)
    }
  }


  private norm(extrasOrOptions){
    // *** Sort ***
    extrasOrOptions = extrasOrOptions.sort((n1,n2) => n1.position - n2.position);

    // *** Norm ***
    let i:number  = 0
    for(let extrasOrOption of extrasOrOptions){
      extrasOrOption.position = i++;
    }
  }


  save() {
    this.util.isModalOpen = false

    if (this.type === ITEM) {
      // avoid prices like 5.7555555555
      this.item.price = this.util.roundPrice(this.item.price);
      this.item.specialPrice = this.util.roundPrice(this.item.specialPrice);
      this.item.takeAwayPrice = this.util.roundPrice(this.item.takeAwayPrice);

      this.item.allergenic = ''
      this.item.additives = ''
      for (let key of Object.keys(this.allergene)) {
        if (this.allergene[key].selected) this.item.allergenic += key
      }

      for (let key of Object.keys(this.zusatzstoffe)) {
        if (this.zusatzstoffe[key].selected) this.item.additives += key
      }
    }

    switch (this.type) {
      case SERVICE: this.modalCtrl.dismiss(this.service); return;
      case CATEGORY:
      case SUBCATEGORY: this.modalCtrl.dismiss(this.category); return;
      case ITEM: this.util.log("Im Modal noch beim Dismiss", this.item); this.modalCtrl.dismiss(this.item); return;
      default: this.modalCtrl.dismiss()
    }
  }

  copyCat() {
    if (this.category.parentCatID > -1 || (this.category.categories && this.category.categories.length > 0)) {
      this.util.presentToast("Kopier-Funktion ist nur für 1st-Level Kategorien vorhanden ohne Unterkategorien", 4000, "toas-warning")
      return
    }
    let newCategory = Object.assign(new Category(this.category.name, this.category.position, this.category.parentCatID), this.category)
    newCategory.id = new Date().getTime()
    let currentTime = new Date().getTime()
    for (let item of newCategory.items) {
      while (currentTime == new Date().getTime()) console.log()  //Wait for new ID
      //TODO item = Object.assign(new Item(this.category.name, this.category.position, this.category.parentCatID), this.category)
      item.id = new Date().getTime()
      currentTime = new Date().getTime()
      item.parentCatID = newCategory.id
      item.rootCatID = newCategory.id
    }

    this.db.currentMenu.category.push(newCategory)
    this.db.updateRestaurant(this.db.currentRestaurantKey)
    this.db.updateMenu(this.db.currentMenuKey)
  }

  getDesc(): string {
    switch (this.type) {
      case SERVICE: return "Service"
      case CATEGORY: return "Kategorie"
      case SUBCATEGORY: return "Unterkategorie"
      default: return "Artikel"
    }
  }

  selectServiceColor(service: ServiceItem, color: string) {
    service.color = color
    this.selectServiceColorExpanded = false;
  }

  toggleServiceColors() {
    this.selectServiceColorExpanded = true;
  }
  /*
    async showSelectServiceColor(service: ServiceItem) {
      const alert = await this.alertController.create({
        header: 'Farbe des Service',
        inputs: [
          {
            name: 'servicered',
            type: 'radio',
            label: 'Rot',
            value: 'servicered',
            checked: ('servicered' === service.color)
          },
          {
            name: 'servicegreen',
            type: 'radio',
            label: 'Grün',
            value: 'servicegreen',
            checked: ('servicegreen' === service.color)
          },
          {
            name: 'serviceyellow',
            type: 'radio',
            label: 'Gelb',
            value: 'serviceyellow',
            checked: ('serviceyellow' === service.color)
          }
        ],
        buttons: [
          {
            text: 'Abbrechen',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              this.util.log('Confirm Cancel');
            }
          }, {
            text: 'Speichern',
            handler: (data: any) => {
              if (data) {
                service.color = '' + data
              }
            }
          }
        ]
      });
  
      await alert.present();
    }*/

}

